import {
  FORGOTTEN_PASSWORD_BEGIN,
  FORGOTTEN_PASSWORD_SUCCESS,
  FORGOTTEN_PASSWORD_FAILURE,
} from "../actions/forgottenpasswordactions";

const initialState = {
  loading: false,
};

export function forgottenPasswordReducer(state = initialState, action) {
  const nextState = Object.assign({}, state);
  switch (action.type) {
    case FORGOTTEN_PASSWORD_BEGIN:
      nextState.loading = true;
      return nextState;
    case FORGOTTEN_PASSWORD_SUCCESS:
      nextState.loading = false;
      return nextState;
    case FORGOTTEN_PASSWORD_FAILURE:
      nextState.loading = false;
      return nextState;
    default:
      return state;
  }
}
